module.exports = __webpack_public_path__ + "static/media/we-are-one-white.c0a368be.png";